import React, { useState, useEffect } from "react";
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from "@material-ui/core/styles";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import { Create, Add, PersonPinCircleRounded } from "@material-ui/icons";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import ReactTable from "components/ReactTable/ReactTable.js";
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { wsGetAll } from "services/WService.js";

import ModalEmployeePosition from "./Modal";
import { useModal } from "hooks/useModal";
import { Toasty, useToasty } from "hooks/Toasty";
import ButtonDelete from "hooks/ButtonDelete";
import { WithApp } from "contexts/appContext";

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
});

const columns = [
  { Header: "#", accessor: "num", excelEnabled: false },
  { Header: "Código", accessor: "code" },
  { Header: "Descripción", accessor: "description" },
  { Header: "", accessor: "actions" }
];

export default WithApp(function EmployeeStatus(props) {
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [employeePositions, setEmployeePositions] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function loadEmployeePositions() {
    setDataLoading(true);
    let response = await wsGetAll("base/employee-positon");
    setDataLoading(false);
    if (response.success) setEmployeePositions(response.data);
  }

  useEffect(() => {
    loadEmployeePositions();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <ModalEmployeePosition
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={loadEmployeePositions}
      />
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.BASE_EMPLOYEE_POSITIONS_STORE}
              component={
                <CardIcon color="primary">
                  <PersonPinCircleRounded style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>
              Listado de estado de empleados
              {dataLoading && <LoadingSpinner />}
            </h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Posición-de-empleados"
              defaultWidth={1200}
              indexRow={[0, 1, 3]}
              widthRow={[150, 200, 5]}
              columns={columns}
              data={employeePositions.map((employeePosition, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard
                        permission={ConstantPermissions.BASE_EMPLOYEE_POSITIONS_UPDATE}
                      >
                        <Button
                          justIcon
                          round
                          simple
                          color="info"
                          className="like"
                          onClick={() => setOpen(employeePosition)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard
                        permission={ConstantPermissions.BASE_EMPLOYEE_POSITIONS_DELETED}
                      >
                        <ButtonDelete
                          entity="base/employee-positon"
                          id={employeePosition.id}
                          reload={loadEmployeePositions}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  code: employeePosition.code,
                  description: employeePosition.description,
                  actions: ""
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
